import React from 'react';
import { object, bool } from 'prop-types';
import { FormattedMessage, intlShape } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import { types as sdkTypes } from '../../util/sdkLoader';
import get from 'lodash/get';

import css from './BookingBreakdown.css';

const { Money } = sdkTypes;

const LineItemBond = props => {
  const { intl, isVisible, transaction } = props;

  const bondFee = isVisible && get(transaction, 'attributes.protectedData.bondFee');

  const bondLabel = <FormattedMessage id="BookingBreakdown.bond" />;

  const rawBond =
    bondFee && bondFee.amount && bondFee.currency
      ? new Money(bondFee.amount, bondFee.currency)
      : null;

  const formattedBondfee = rawBond ? formatMoney(intl, rawBond) : null;

  return bondFee ? (
    <>
      <hr className={css.totalDivider} />
      <div className={css.lineItemBond}>
        <div className={css.totalLabel}>{bondLabel}</div>
        <div className={css.totalPrice}>{formattedBondfee}</div>
      </div>
    </>
  ) : null;
};

LineItemBond.propTypes = {
  intl: intlShape.isRequired,
  bondFee: object,
  isVisible: bool,
};

export default LineItemBond;
